(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-review-photo-trigger]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('data-dialog-target'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closeButton = event.target.closest('[data-dialog-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('review-card__photo-dialog')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
